const PRINCIPLES = [
  { icon: "ri-book-open-line", title: "实用优先", desc: "所有教程都以“能落地”为准，不堆术语，跟着步骤就能操作。" },
  { icon: "ri-seedling-line", title: "持续更新", desc: "随下载方式与工具迭代，持续补充新内容，保持教程不过时。" },
  { icon: "ri-heart-3-line", title: "尊重版权", desc: "我们只分享下载方法与整理技巧，不提供任何资源本身。" },
];

const REVIEWS = [
  {
    name: "阿柚",
    role: "漫画收集党",
    text: "照着四步走，第一次就把整系列打包存好了，再也不用一本本刷屏保存。",
    avatar: "柚",
  },
  {
    name: "小鹿",
    role: "网速不稳定用户",
    text: "离线下载那部分救我大命，白天挂着晚上收，断了还能续，稳得很。",
    avatar: "鹿",
  },
  {
    name: "大木",
    role: "整理强迫症",
    text: "命名规范和归档那两招很好用，现在本地目录整整齐齐，找什么都快。",
    avatar: "木",
  },
];

export default function About() {
  return (
    <section id="about" className="relative w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-accent-600">
              <i className="ri-hand-heart-line"></i>
              关于我们
            </span>
            <h2 className="font-display text-2xl md:text-4xl text-foreground-950 mt-3 leading-snug">
              做一份真正帮得上忙的
              <br className="hidden md:block" />
              本子网站下载指南
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              「漫藏手册」的初衷很简单——很多朋友喜欢收藏本子资源，却被“怎么下、怎么存、怎么整理”卡住。
              我们把本子网站打包下载、批量下载与离线下载的实操方法整理成一套清晰教程，
              希望每个想存资源的人都能少踩坑、少走弯路，安稳把喜欢的内容留在本地。
            </p>

            <div className="mt-6 space-y-3">
              {PRINCIPLES.map((p) => (
                <div key={p.title} className="flex items-start gap-3">
                  <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-700">
                    <i className={`${p.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950">{p.title}</h3>
                    <p className="mt-0.5 text-xs text-foreground-600 leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="rounded-3xl overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20hand%20drawn%20anime%20style%20illustration%20of%20a%20young%20collector%20organizing%20a%20shelf%20of%20doujin%20books%20and%20digital%20tablet%2C%20cozy%20study%20corner%2C%20coral%20peach%20and%20amber%20tones%2C%20flat%20art%20with%20soft%20textures%2C%20welcoming%20and%20detailed%2C%20clean%20composition&width=900&height=700&seq=about-collection-2026&orientation=portrait"
                alt="漫藏手册 - 本子网站资源下载整理归档插画"
                title="本子网站下载方式整理归档"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>

        <div className="mt-14">
          <h3 className="font-display text-lg md:text-2xl text-foreground-950 text-center">
            大家是怎么评价我们的
          </h3>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-5">
            {REVIEWS.map((r) => (
              <figure
                key={r.name}
                className="rounded-2xl border border-background-200 bg-background-100 p-6"
              >
                <div className="flex items-center gap-1 text-accent-500 text-sm">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill"></i>
                  ))}
                </div>
                <blockquote className="mt-4 text-sm text-foreground-700 leading-relaxed">
                  “{r.text}”
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-sm font-semibold">
                    {r.avatar}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{r.name}</p>
                    <p className="text-xs text-foreground-500">{r.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}